import React from 'react';

import { ZoomableImage } from '@vp/swan';

import { Image } from '../../domain/Image';
import { useResponsiveCloudinaryImage } from '../../libs/useResponsiveCloudinaryImage';

export interface SwanZoomableGalleryImageProps {
  image: Image;
  alt: string;
  onExpandClick?: () => void;
}

export const SwanZoomableGalleryImage: React.FC<SwanZoomableGalleryImageProps> = ({
  image,
  alt,
  onExpandClick,
}) => {
  const { src, srcSet } = useResponsiveCloudinaryImage(image.gallery);

  const zoomSrcSet = `${srcSet}, ${image.zoom} 3x`;

  return <ZoomableImage src={src} srcSet={zoomSrcSet} alt={alt} onExpandClick={onExpandClick} />;
};
